<section class="analytics-row">
  <ng-container *ngIf="!isAdmin; else adminAnalytics">
    <div class="panel analytics-panel">
      <div class="panel-header">
        <h3>Your Performance vs Team</h3>
        <kendo-dropdownlist [data]="timeRanges"
                            [value]="selectedTimeRange"
                            (valueChange)="onTimeRangeChange($event)"
                            [style.width.px]="140">
        </kendo-dropdownlist>
      </div>
      <div class="panel-body">
        <div class="chart-container">
          <kendo-chart [style.height.px]="280">
            <kendo-chart-legend position="bottom" orientation="horizontal"></kendo-chart-legend>
            <kendo-chart-category-axis>
              <kendo-chart-category-axis-item [categories]="chartCategories">
              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
            <kendo-chart-series>
              <kendo-chart-series-item type="column"
                                       [data]="userPerformanceData"
                                       name="You"
                                       [color]="'#1976d2'">
              </kendo-chart-series-item>
              <kendo-chart-series-item type="column"
                                       [data]="teamPerformanceData"
                                       name="Team Avg"
                                       [color]="'#e0e0e0'">
              </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-value-axis>
              <kendo-chart-value-axis-item [title]="{ text: 'Requests Completed' }">
              </kendo-chart-value-axis-item>
            </kendo-chart-value-axis>
          </kendo-chart>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #adminAnalytics>
    <div class="panel analytics-panel">
      <div class="panel-header">
        <h3>Group Analytics</h3>
        <kendo-dropdownlist [data]="timeRanges"
                            [value]="selectedTimeRange"
                            (valueChange)="onTimeRangeChange($event)"
                            [style.width.px]="140">
        </kendo-dropdownlist>
      </div>
      <div class="panel-body no-padding">
        <kendo-grid [data]="groupAnalytics" class="group-grid">
          <kendo-grid-column field="name" title="Employee"></kendo-grid-column>
          <kendo-grid-column field="completed" title="Completed" [width]="110"></kendo-grid-column>
          <kendo-grid-column field="inProgress" title="In Progress" [width]="120"></kendo-grid-column>
          <kendo-grid-column field="avgTurnaround" title="Avg Turnaround" [width]="130">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.avgTurnaround | number:'1.1-1' }} days
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="activeRequests" title="Active" [width]="90"></kendo-grid-column>
        </kendo-grid>
      </div>
    </div>
  </ng-template>

  <div class="panel analytics-panel status-breakdown">
    <div class="panel-header">
      <h3>Request Status Breakdown</h3>
    </div>
    <div class="panel-body">
      <div class="chart-container">
        <kendo-chart [style.height.px]="280">
          <kendo-chart-series>
            <kendo-chart-series-item type="donut"
                                     [data]="statusChartData"
                                     field="value"
                                     categoryField="status"
                                     [holeSize]="60">
              <kendo-chart-series-item-labels [visible]="false">
              </kendo-chart-series-item-labels>
            </kendo-chart-series-item>
          </kendo-chart-series>
          <kendo-chart-legend position="right" orientation="vertical">
          </kendo-chart-legend>
        </kendo-chart>
      </div>
      <div class="status-legend">
        <div class="legend-item" *ngFor="let item of statusChartData">
          <span class="legend-color" [style.background]="item.color"></span>
          <span class="legend-label">{{ item.status }}</span>
          <span class="legend-value">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="panel analytics-panel">
    <div class="panel-header">
      <h3>Avg Turnaround Time</h3>
    </div>
    <div class="panel-body turnaround-stats">
      <div class="turnaround-item">
        <span class="turnaround-value">{{ avgTurnaroundDays.user }}</span>
        <span class="turnaround-label">Your Avg (days)</span>
        <div class="turnaround-bar">
          <div class="bar-fill user" [style.width.%]="(avgTurnaroundDays.user / 10) * 100"></div>
        </div>
      </div>
      <div class="turnaround-item">
        <span class="turnaround-value">{{ avgTurnaroundDays.team }}</span>
        <span class="turnaround-label">Team Avg (days)</span>
        <div class="turnaround-bar">
          <div class="bar-fill team" [style.width.%]="(avgTurnaroundDays.team / 10) * 100"></div>
        </div>
      </div>
      <div class="turnaround-comparison" [class.better]="avgTurnaroundDays.user < avgTurnaroundDays.team">
        <span class="k-icon" [ngClass]="avgTurnaroundDays.user < avgTurnaroundDays.team ? 'k-i-check-circle' : 'k-i-warning'"></span>
        <span *ngIf="avgTurnaroundDays.user < avgTurnaroundDays.team">
          {{ ((avgTurnaroundDays.team - avgTurnaroundDays.user) / avgTurnaroundDays.team * 100) | number:'1.0-0' }}% faster than team
        </span>
        <span *ngIf="avgTurnaroundDays.user >= avgTurnaroundDays.team">
          {{ ((avgTurnaroundDays.user - avgTurnaroundDays.team) / avgTurnaroundDays.team * 100) | number:'1.0-0' }}% slower than team
        </span>
      </div>
    </div>
  </div>
</section>
